import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { getContractsFetched } from '../../State/selectors/mdqx/selectors';
import { GetContractsRequest } from '../../State/actions/mdqx/contract.actions';
import { State } from '../../State';

@Injectable({
    providedIn: 'root',
})
export class ContractResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getContractsFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetContractsRequest()),
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
